<template>
    <div>
    <!--home content-->
    <div class="home-container">
        <!-- banner-->
        <div class="banner">
            <PopupHome />
            <BarreRecherche @submit-search="submitSearch" />
        </div>
        <!--fin banner-->
    </div>
    <!--Recherche par revue-->
    <BlocRevue />
    <!--bloc newsletter-->
    <!-- <BlocNewsletter /> -->

    </div>

</template>

<script>
/* eslint-disable */
import PopupHome from '@/components/home/PopupHome.vue';
import BarreRecherche from '@/components/recherche/BarreRecherche.vue';
import BlocRevue from '@/components/recherche/BlocRevue.vue';
import BlocNewsletter from '@/components/newsletter/BlocNewsletter.vue';
import { mapState, mapActions, mapGetters } from 'vuex'

export default {
    name: "HomePage",
    components: {
        PopupHome,
        BarreRecherche,
        BlocRevue,
        // BlocNewsletter
    },
    computed: {
        ...mapState([
            'auth',
        ])
    },
    methods: {
        ...mapActions([
            'setSearchFilters'
        ]),
        submitSearch() {
            this.$router.push({ name: 'rechecherPage' })
        }
    },
}
</script>
<style lang="scss" scoped>
    @import "@/scss/helpers/mixins";
    @import "@/scss/helpers/variables";

.home-container {
    max-width: 100%;
    margin-right: auto;
    background: #283861;
    padding: 3em 0;
    border-bottom-left-radius: 50% 30px;
    border-bottom-right-radius: 50% 30px;
    overflow: hidden;
    background: url('@/assets/images/patern_blue.jpg') no-repeat 0 0 $main;
    background-size: auto 100%;

    @media screen and (max-width: 991px) {
        padding: 3em 1em;
    }

    @include min($lg) {
        background-size: 100% auto;
    }

    .banner {
        max-width: 1024px;
        margin: auto;
        input[type=search]{
            border: 0;
        }
        
    }
}

.bloc-publicitaire {
    background: #AFB1B8 0% 0% no-repeat padding-box;
    padding: 3rem;
    max-width: 700px;
    text-align: center;
    margin: 25px auto;
    @media screen and (max-width: 991px) {
        margin: 25px;
        padding: 2rem;
    }
}
</style>